const AlertIconMenu = () => {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect
        width="32"
        height="32"
        rx="6.64935"
        fill="url(#paint0_linear_2496_3483)"
        fill-opacity="0.1"
      />
      <g clip-path="url(#clip0_2496_3483)">
        <path
          d="M8.52881 24.4999V23.5109H9.51746V21.4883H22.4847V23.4991H23.4851V24.4999H8.52881Z"
          fill="#052351"
        />
        <path d="M7.49854 15.4946H9.51343V16.4915H7.49854V15.4946Z" fill="#052351" />
        <path
          d="M10.6854 20.4665C10.7262 20.0933 10.7654 19.7309 10.8057 19.3687C10.8889 18.6214 10.973 17.8743 11.0564 17.127C11.1411 16.3688 11.2257 15.6105 11.3098 14.8522C11.3812 14.2093 11.4478 13.5658 11.5269 12.9238C11.5378 12.8362 11.5892 12.7327 11.6556 12.676C12.2739 12.1486 13.0126 11.8786 13.794 11.7132C14.8029 11.4997 15.824 11.4706 16.85 11.5333C17.6873 11.5843 18.5076 11.7178 19.2895 12.0367C19.6864 12.1986 20.0569 12.4059 20.3794 12.6906C20.4286 12.7341 20.4773 12.8035 20.4845 12.8656C20.6025 13.8983 20.7124 14.9319 20.8271 15.965C20.943 17.009 21.0626 18.0526 21.1801 19.0965C21.2272 19.5141 21.2735 19.9317 21.3191 20.3494C21.3231 20.3864 21.3196 20.4243 21.3196 20.4701H16.5186C16.5146 20.4312 16.507 20.3895 16.5068 20.3476C16.5057 20.0707 16.5112 19.7938 16.5036 19.5171C16.5009 19.4171 16.5396 19.3761 16.6255 19.3351C17.2751 19.0258 17.6035 18.3757 17.4684 17.6806C17.3439 17.0391 16.7835 16.5533 16.102 16.4959C15.4189 16.4382 14.7579 16.9123 14.5706 17.594C14.3805 18.2862 14.7013 19.0068 15.3536 19.314C15.4843 19.3755 15.5142 19.4457 15.5105 19.5753C15.5021 19.8681 15.5079 20.1611 15.5079 20.4663H10.6853L10.6854 20.4665Z"
          fill="#052351"
        />
        <path d="M15.5122 9.49878V7.5H16.4937V9.49878H15.5122Z" fill="#052351" />
        <path d="M22.4966 16.4795V15.5037H24.5016V16.4795H22.4966Z" fill="#052351" />
        <path
          d="M11.7466 11.0536C11.5238 11.2764 11.2939 11.5061 11.0757 11.7242C10.6247 11.2734 10.1603 10.809 9.7085 10.3575C9.92039 10.1454 10.1531 9.91261 10.3789 9.68652C10.826 10.1334 11.2909 10.5981 11.7466 11.0537V11.0536Z"
          fill="#052351"
        />
        <path
          d="M21.6568 9.69043C21.8644 9.89837 22.0942 10.1283 22.3127 10.3472C21.8566 10.8011 21.3892 11.2661 20.9289 11.7241C20.7219 11.5164 20.4928 11.2865 20.2764 11.0693C20.7312 10.615 21.1977 10.149 21.6567 9.69043H21.6568Z"
          fill="#052351"
        />
        <path
          d="M16.0153 17.4892C16.2894 17.4925 16.505 17.7116 16.5049 17.9867C16.5048 18.2683 16.2815 18.4879 15.9987 18.4845C15.7188 18.481 15.5026 18.2537 15.5094 17.97C15.5159 17.6979 15.7392 17.4857 16.0154 17.4891L16.0153 17.4892Z"
          fill="#052351"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_2496_3483"
          x1="15.7922"
          y1="0"
          x2="15.7922"
          y2="32"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#0062FF" />
          <stop offset="1" stop-color="#004BC2" />
        </linearGradient>
        <clipPath id="clip0_2496_3483">
          <rect width="17.0031" height="17" fill="white" transform="translate(7.49854 7.5)" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default AlertIconMenu
